import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const ACCOUNT_MANAGER_VIDEO_REPORT_ID = `account-manager${VIDEO_CAMPAIGN_SUFFIX}`;
